/* Index_object_clients_marquee */
initMarquee('.Index_object_clients_marquee', {
    mobile: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    },
    desktop: {
        duration: 80000,
        gap: 0,
        duplicated: true,
        direction: "left"
    }
});
/* Index_object_clients_marquee */